import apiClient from "./axios"

export const getModels = async (params = {}) => {
  const { data } = await apiClient.get("/models", { params })
  return data
}

export const getModel = async id => {
  const { data } = await apiClient.get(`/models/${id}`)
  return data
}

export const getModelsByBrand = async (brandIdentifier, params = {}) => {
  const { data } = await apiClient.get(`/models/brand/${brandIdentifier}`, {
    params,
  })
  return data
}

export const createModel = async modelData => {
  const { data } = await apiClient.post("/models", modelData)
  return data
}

export const editModel = async ({ id, ...modelData }) => {
  const { data } = await apiClient.patch(`/models/${id}`, modelData)
  return data
}

export const deleteModel = async id => {
  const { data } = await apiClient.delete(`/models/${id}`)
  return data
}
